








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class IconExport extends Vue {
  @Prop({ required: false }) readonly color?: string;
}
